import { getUserModuleState, UserState } from "#login/store/reducers";
import { createSelector } from "@ngrx/store";
import * as userProfileReducers from "#login/store/reducers/login-profile.reducer";

// ------PROFILE SELECTORS------
export const getProfileState = createSelector(
    getUserModuleState,
    (state: UserState) => state.profile
);

export const getUserProfile = createSelector(
    getProfileState,
    userProfileReducers.getUserData
);

export const getUserId = createSelector(
    getProfileState,
    userProfileReducers.getUserId
);

export const getUserGUID = createSelector(
    getProfileState,
    userProfileReducers.getUserGUID
);

export const isStudent = createSelector(
    getProfileState,
    userProfileReducers.getIsStudent
);

export const getIsTeacher = createSelector(
    getProfileState,
    userProfileReducers.getIsTeacher
);

export const isViewAsStudent = createSelector(
    getProfileState,
    userProfileReducers.getViewAsStudent
);

export const getViewAsStudentCourseID = createSelector(
    getProfileState,
    userProfileReducers.getViewAsStudentCourseID
);

export const getIsDistributor = createSelector(
    getProfileState,
    userProfileReducers.getIsDistributor
);

export const getUnreadNotificationsCount = createSelector(
    getProfileState,
    userProfileReducers.getUnreadNotificationsCount
);

export const getWebCamStream = createSelector(
    getProfileState,
    userProfileReducers.getWebcamStream
);

export const getTempPwdDetected = createSelector(
    getProfileState,
    userProfileReducers.getTempPwdDetected
);

export const getUpdateProfileError = createSelector(
    getProfileState,
    userProfileReducers.getUpdateProfileError
);

export const getBEIUserID = createSelector(
    getProfileState,
    userProfileReducers.getBEIUserID
);

export const getAccessToken = createSelector(
    getProfileState,
    userProfileReducers.getAccessToken
);
